import { createReducer } from '@reduxjs/toolkit';

import { TradeRequestItem } from 'data/models/TradeRequest';
import { resetTradeRequestsAction, setTradeRequests, setTradeRequestsIsLoading } from 'data/actions/tradeRequests';

export interface State {
  tradeRequests: TradeRequestItem[];
  isLoading: boolean;
}

export const initialState: State = {
  tradeRequests: [],
  isLoading: false,
};

export default createReducer(initialState, builder => {
  builder.addCase(setTradeRequests, (state, action) => {
    state.tradeRequests = action.payload;
  });

  builder.addCase(setTradeRequestsIsLoading, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(resetTradeRequestsAction, (state, action) => {
    if (!action.payload) return state;
    return { ...initialState };
  });
});
